import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import API from "../config/API";
function UserPaymentGateway() {
  const navigate = useNavigate();
  const location = useLocation();

  const user = JSON.parse(localStorage.getItem("user"));

  const payment = location.state?.payment || {};

  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(false);

  const [mobileNumber, setMobileNumber] = useState(payment.mobileNumber || "");

  const [timerStarted, setTimerStarted] = useState(false);
  const [timer, setTimer] = useState(100);

  const [upiId] = useState("svkpg@ybl");

  const qrImage =
    "https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=upi://pay?pa=svkpg@ybl&pn=SVK%20PG";

  useEffect(() => {
    let interval = null;

    if (timerStarted && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    if (timer === 0) {
      alert("Payment Session Expired");
      setTimerStarted(false);
    }

    return () => clearInterval(interval);
  }, [timerStarted, timer]);

  const sendPaymentLink = async () => {
    try {
      setLoading(true);

      const payload = {
        registerId: payment.registerId,
        mobileNumber,
        amount: payment.totalAmount,
        paymentMode: "UPI",
        createdBy: user?.emailId,
      };

      const res = await axios.post(
        `${API.V1}/payments/sendPaymentLink`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${user?.jwtToken}`,
          },
        },
      );

      if (res.data.statusCode === 200) {
        alert("Payment Link Sent Successfully");
        setTimer(100);
        setTimerStarted(true);
      } else {
        alert(res.data.message);
      }
    } catch (e) {
      console.log(e);
      alert("Unable to send payment link");
    } finally {
      setLoading(false);
    }
  };

  const verifyPayment = async () => {
    try {
      setChecking(true);

      const res = await axios.get(`${API.V1}/payments/checkPaymentStatus`, {
        params: {
          registerId: payment.registerId,
        },
        headers: {
          Authorization: `Bearer ${user?.jwtToken}`,
        },
      });

      if (res.data.statusCode === 200) {
        alert("Payment Successful");

        setTimeout(() => {
          navigate("/usersDashboard");
        }, 1500);
      } else {
        alert("Payment is still pending.");
      }
    } catch (err) {
      console.log(err);
      alert("Unable to verify payment.");
    } finally {
      setChecking(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>Secure Payment Gateway</h1>

        <p style={styles.subtitle}>
          Complete your payment securely using any UPI application.
        </p>

        <div style={styles.amountCard}>
          <div style={styles.amountLabel}>Total Amount</div>

          <div style={styles.amount}>₹ {payment.totalAmount || 0}</div>
        </div>

        <div style={styles.grid}>
          {/* LEFT */}

          <div style={styles.leftPanel}>
            <img src={qrImage} alt="QR" style={styles.qrImage} />

            <div style={styles.scanTitle}>Scan QR Code</div>

            <div style={styles.scanText}>
              Google Pay
              <br />
              PhonePe
              <br />
              Paytm
              <br />
              BHIM
            </div>
          </div>

          {/* RIGHT */}

          <div style={styles.rightPanel}>
            <div style={styles.field}>
              <label style={styles.label}>UPI ID</label>

              <div style={styles.upiContainer}>
                <input readOnly value={upiId} style={styles.input} />

                <button
                  style={styles.copyButton}
                  onClick={() => {
                    navigator.clipboard.writeText(upiId);
                    alert("UPI ID Copied");
                  }}
                >
                  Copy
                </button>
              </div>
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Mobile Number</label>

              <input
                type="text"
                maxLength={10}
                value={mobileNumber}
                onChange={(e) =>
                  setMobileNumber(e.target.value.replace(/\D/g, ""))
                }
                placeholder="Enter Mobile Number"
                style={styles.input}
              />
            </div>
            <button
              style={styles.payButton}
              disabled={loading || mobileNumber.length !== 10 || timerStarted}
              onClick={sendPaymentLink}
            >
              {loading ? "Sending..." : "Send Payment Link"}
            </button>{" "}
            {timerStarted && (
              <>
                <div style={styles.timerCard}>
                  <div style={styles.timerTitle}>Waiting for Payment...</div>

                  <div style={styles.timer}>{timer} sec</div>

                  <div style={styles.timerMessage}>
                    Complete the payment using the QR Code or the payment link
                    sent to your mobile.
                  </div>
                </div>

                <button
                  style={styles.verifyButton}
                  disabled={checking}
                  onClick={verifyPayment}
                >
                  {checking ? "Verifying..." : "I've Completed Payment"}
                </button>
              </>
            )}
            <div style={styles.helpCard}>
              <h3 style={styles.helpTitle}>Payment Instructions</h3>

              <ul style={styles.list}>
                <li>✔ Scan the QR Code using any UPI App.</li>

                <li>✔ Or click the payment link received on your mobile.</li>

                <li>✔ Complete the payment before the timer expires.</li>

                <li>
                  ✔ Click <b>I've Completed Payment</b> after payment.
                </li>

                <li>
                  ✔ You'll be redirected automatically after successful
                  verification.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserPaymentGateway;

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg,#eef4ff,#f8fbff)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "40px",
    fontFamily: "'Segoe UI',sans-serif",
  },

  card: {
    width: "100%",
    maxWidth: "1100px",
    background: "#fff",
    borderRadius: "20px",
    padding: "35px",
    boxShadow: "0 15px 40px rgba(0,0,0,.12)",
  },

  title: {
    textAlign: "center",
    color: "#1e40af",
    fontSize: "34px",
    fontWeight: "700",
    marginBottom: "8px",
  },

  subtitle: {
    textAlign: "center",
    color: "#64748b",
    marginBottom: "30px",
    fontSize: "16px",
  },

  amountCard: {
    background: "linear-gradient(135deg,#2563eb,#3b82f6)",
    color: "#fff",
    borderRadius: "16px",
    padding: "22px",
    textAlign: "center",
    marginBottom: "30px",
  },

  amountLabel: {
    fontSize: "16px",
    opacity: 0.9,
  },

  amount: {
    fontSize: "42px",
    fontWeight: "700",
    marginTop: "8px",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "350px 1fr",
    gap: "35px",
    alignItems: "flex-start",
  },

  leftPanel: {
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    borderRadius: "16px",
    padding: "25px",
    textAlign: "center",
  },

  qrImage: {
    width: "260px",
    height: "260px",
    objectFit: "contain",
    border: "10px solid #fff",
    borderRadius: "15px",
    boxShadow: "0 10px 25px rgba(0,0,0,.15)",
  },

  scanTitle: {
    marginTop: "18px",
    fontSize: "20px",
    fontWeight: "700",
    color: "#1e40af",
  },

  scanText: {
    marginTop: "10px",
    color: "#64748b",
    lineHeight: "24px",
    fontSize: "15px",
  },

  rightPanel: {
    display: "flex",
    flexDirection: "column",
  },

  field: {
    marginBottom: "22px",
  },

  label: {
    display: "block",
    marginBottom: "8px",
    fontWeight: "600",
    color: "#334155",
  },

  upiContainer: {
    display: "flex",
    gap: "10px",
  },

  input: {
    flex: 1,
    width: "100%",
    padding: "14px",
    border: "1px solid #cbd5e1",
    borderRadius: "10px",
    outline: "none",
    fontSize: "15px",
    boxSizing: "border-box",
  },

  copyButton: {
    padding: "0 20px",
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    fontWeight: "600",
  },

  payButton: {
    width: "100%",
    padding: "15px",
    background: "linear-gradient(90deg,#16a34a,#22c55e)",
    color: "#fff",
    border: "none",
    borderRadius: "12px",
    fontSize: "17px",
    fontWeight: "700",
    cursor: "pointer",
    marginTop: "5px",
  },

  timerCard: {
    marginTop: "25px",
    padding: "22px",
    background: "#eff6ff",
    border: "2px solid #bfdbfe",
    borderRadius: "15px",
    textAlign: "center",
  },

  timerTitle: {
    color: "#1d4ed8",
    fontWeight: "700",
    fontSize: "18px",
  },

  timer: {
    fontSize: "42px",
    fontWeight: "700",
    color: "#dc2626",
    margin: "15px 0",
  },

  timerMessage: {
    color: "#475569",
    lineHeight: "24px",
    fontSize: "15px",
  },

  verifyButton: {
    marginTop: "20px",
    width: "100%",
    padding: "15px",
    background: "linear-gradient(90deg,#2563eb,#3b82f6)",
    color: "#fff",
    border: "none",
    borderRadius: "12px",
    fontSize: "17px",
    fontWeight: "700",
    cursor: "pointer",
  },

  helpCard: {
    marginTop: "30px",
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    borderRadius: "15px",
    padding: "20px",
  },

  helpTitle: {
    margin: 0,
    marginBottom: "15px",
    color: "#1e40af",
    fontSize: "20px",
    fontWeight: "700",
  },

  list: {
    margin: 0,
    paddingLeft: "22px",
    lineHeight: "30px",
    color: "#475569",
    fontSize: "15px",
  },
};
